const apiUrl = process.env.REACT_APP_API_URL;
export const PostProjecteClonar = async (id: any, clonar : string, sprint: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id}/clone?projecte=${clonar}&sprint=${sprint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok && response.status !== 201) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
